// Координаты городов
export const TOLYATTI_COORDINATES = {
  PASSENGER_AND_COMMERCIAL: [53.517944, 49.59073],
  TRUCKS_AND_TRAILERS: [53.516339, 49.592028],
};

export const CITY_COORDINATES = {
  52: TOLYATTI_COORDINATES.TRUCKS_AND_TRAILERS, // Тольятти
  107: [55.693953, 52.418386], // Набережные челны
  110: [55.846071, 48.85123], // Казань
  124: [56.891498, 60.778075], // Екатеринбург
  157: [54.662803, 55.736787], // Уфа
};
